import { Controller, useFormContext } from "react-hook-form";
import PasswordInput from "~/common/components/materialInput/PasswordInput";
import { MenuItem, Stack, TextField } from "@schaeffler-commerce/design-system";
import { PasswordRequirements } from "./PasswordRequirements";
import type { CompleteRegistrationFormValues, Field, FieldRow } from "../../api/getOnboardingInitialData";

export const StepFields = ({ fields }: { fields: FieldRow[] }) => {
  const { control, getValues, trigger, watch } = useFormContext<CompleteRegistrationFormValues>();
  const password = watch("password") ?? "";

  const renderField = (field: Field) => {
    return (
      <Controller
        key={field.name}
        name={field.name}
        control={control}
        rules={field.rules}
        render={({ field: controllerField, fieldState }) => {
          if (field.type === "select") {
            return (
              <TextField
                select
                fullWidth
                label={field.label}
                {...controllerField}
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
              >
                {field.dropdownOptions?.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            );
          }

          if (field.type === "password") {
            return (
              <>
                <PasswordInput
                  {...controllerField}
                  label={field.label}
                  error={!!fieldState.error}
                  helperLabel={fieldState.error?.message}
                  onChange={(event) => {
                    controllerField.onChange(event);

                    if (field.name === "password" && getValues("confirmPassword")) {
                      void trigger("confirmPassword");
                    }
                  }}
                />

                {field.name === "confirmPassword" && <PasswordRequirements password={password} />}
              </>
            );
          }

          return (
            <TextField
              fullWidth
              label={field.label}
              {...controllerField}
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
            />
          );
        }}
      />
    );
  };

  return (
    <Stack
      sx={{
        gap: 2,

        "& .MuiOutlinedInput-root": {
          backgroundColor: "surface.bright",
        }
      }}>
      {fields.map((field, index) =>
        Array.isArray(field) ? (
          <Stack key={index} direction="row" sx={{
            gap: 2
          }}>
            {field.map(renderField)}
          </Stack>
        ) : (
          renderField(field)
        ),
      )}
    </Stack>
  );
};
